module.exports = __webpack_public_path__ + "static/media/hot1.90cb533a.jpg";